import { fbt, useLocaleContext } from 'fbtee'
import { CalendarDays } from 'lucide-react'
import { SettingsRow } from '../../components/SettingsCard'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select'
import { useWeekStart } from '../../hooks/useWeekStart'
import { toBcp47 } from '@shared/dates'
import type { WeekStartPref } from '@shared/preferences'

// 2024-01-07 was a Sunday, 2024-01-08 a Monday.
function weekdayName(day: 0 | 1, locale: string): string {
  return new Date(Date.UTC(2024, 0, day === 0 ? 7 : 8)).toLocaleDateString(toBcp47(locale), { weekday: 'long', timeZone: 'UTC' })
}

export function WeekStartSettingsRow() {
  const { locale } = useLocaleContext()
  const { pref, autoWeekStartsOn, setPref } = useWeekStart()
  const autoDay = weekdayName(autoWeekStartsOn, locale)

  return (
    <SettingsRow
      icon={<CalendarDays className="size-4" />}
      label={
        <label htmlFor="settings-week-start">
          {fbt('Week starts on', "Label for the Settings option choosing the plans calendar's first day of the week")}
        </label>
      }
      trailing={
        <Select value={pref} onValueChange={v => setPref(v as WeekStartPref)}>
          <SelectTrigger id="settings-week-start" data-testid="settings-week-start" className="w-40 capitalize">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="auto" className="capitalize">
              <fbt desc="Week start option that follows the phone's setting or the app language; the param is the weekday it resolves to">
                Auto (<fbt:param name="weekday">{autoDay}</fbt:param>)
              </fbt>
            </SelectItem>
            <SelectItem value="monday" className="capitalize">{weekdayName(1, locale)}</SelectItem>
            <SelectItem value="sunday" className="capitalize">{weekdayName(0, locale)}</SelectItem>
          </SelectContent>
        </Select>
      }
    />
  )
}
